import React, { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { secToHour, secToMinute } from '../../../../../utils/date'
import BarGraphBase from './BarGraphBase'

interface Judgement {
  count: number
  time: number
}

interface Heatmap {
  type: string
  range: string
  target: string
  id: number
  title: string
  legend: string
  startColor: string
  endColor: string
  minimum: number
  displaySearchLink: boolean
  name: string
}

interface Search {
  startDate: string
  endDate: string
  teamIds: number[]
  teamNames: string[]
  memberIds: number[]
  memberNames: string[]
  keywords: string[]
  serviceNames: string[]
  categoryIds: number[]
  categoryNames: string[]
  efficiencyLevel: string[]
  stressLevel: string[]
  focusLevel: string[]
  sortKey?: string,
  sortType?: string,
}

interface Props {
  target: string,
  judgements: {
    a_judgement: Judgement
    b_judgement: Judgement
    c_judgement: Judgement
    checked: boolean
  } | undefined
  score: string,
  heatmapModalOpenCallback: (heatmap: Heatmap) => void,
}

const WeeklyJudgement: FC<Props> = (props) => {
  const {
    target,
    judgements,
    score,
    heatmapModalOpenCallback,
  } = props

  const { t } = useTranslation()

  const totalTime = useMemo(() => {
    if (!judgements) return 0
    return (judgements.a_judgement.time + judgements.b_judgement.time + judgements.c_judgement.time)
  }, [judgements])

  const buildJudgement = (rank: string, judgement?: Judgement, checked = false) => {
    if (!judgement) return ""
    return (
      <>
        <div
          className={`judgement_area ${checked && "checked"}`}
          key={`${rank}_${judgement.count}_${judgement.time}`}
        >
          <div className="text_area">
            <div className="text">
              {t(`report.weekly.judgement.${score}.${rank}`)}
            </div>
            <button
              type="button"
              onClick={
                () => heatmapModalOpenCallback({
                  type: "hour",
                  range: "weekly",
                  target: target,
                  id: 1,
                  title: "judgement",
                  legend: `${t(`report.weekly.judgement.${score}.${rank}`)}(${t(`report.detail.unit.hour`)})`,
                  startColor: "#ECF0F5",
                  endColor: "#008FFB",
                  minimum: 0,
                  displaySearchLink: true,
                  name: `${score}_${rank}`,
                })
              }
            >
              比較データを見る
            </button>
          </div>
          <div className="graph_wrap">
            <BarGraphBase
              value={(judgement.time / (totalTime * 1.1)) * 100}
            />
            <div
              className="value"
              style={{
                left: `${((judgement.time / (totalTime * 1.1)) * 100) + 1}%`,
              }}
            >
              {
                secToHour(judgement.time) ? (
                  <>
                    {secToHour(judgement.time)}
                    時間
                  </>
                ) : (
                  <>
                  </>
                )
              }
              {
                secToMinute(judgement.time) ? (
                  <>
                    {secToMinute(judgement.time)}
                    分
                  </>
                ) : (
                  <>
                  </>
                )
              }
            </div>
          </div>
          {
            checked && (
              <ReactSVG
                src="/static/images/icon/icon-warn.svg"
                className="icon_warn"
              />
            )
          }
        </div>
      </>
    )
  }

  return (
    <>
      {buildJudgement('a', judgements?.a_judgement)}
      {buildJudgement('c', judgements?.c_judgement, judgements?.checked)}
    </>
  )
}

export default WeeklyJudgement
